import React from "react";
import styled, { css } from "styled-components";
import { LivecourseStatus } from "@domain/livecourse/livecourse";

interface OnGoingLiveCourseIconProps extends React.HTMLAttributes<HTMLDivElement> {
	status?: string;
}
export const OnGoingLiveCourseIcon: React.FC<OnGoingLiveCourseIconProps> = ({ status }) => {
	return <Dot status={status} />;
};

const Dot = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "status",
})<{ status?: string }>`
	/* margin-top: 4px; */
	height: 10px;
	width: 10px;
	border-radius: 50%;
	display: inline-block;
	background: rgba(255, 82, 82, 1);
	box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);

	${({ status }) =>
		status === LivecourseStatus.STATUS
			? undefined
			: css`
					animation: pulse 1s infinite;
					-moz-animation: pulse 1s infinite;
					-webkit-animation: pulse 1s infinite;
				`}

	@keyframes pulse {
		0% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
		}

		70% {
			transform: scale(1);
			box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
		}

		100% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
		}
	}
`;
